import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    routes: [
        {
            name: 'Login',
            meta: '登录',
            path: '/login',
            component: () => import('@/views/admin/login')
        },
        {
            name: 'Index',
            meta: '首页',
            path: '/index',
            component: () => import('@/views/admin/index')
        },
        {
            name: 'Wait',
            meta: '加载',
            path: '/wait',
            component: () => import('@/views/admin/wait')
        },
        {
            name: 'Main',
            meta: '框架',
            path: '/main',
            component: () => import('@/views/admin/main'),
            children: [
                {
                    name: 'Home',
                    meta: '工作台',
                    path: '/home',
                    component: () => import('@/views/dash/home')
                },
                {
                    name: 'Trade',
                    meta: '我的工单',
                    path: '/trade',
                    component: () => import('@/views/dash/trade')
                },
                {
                    name: 'Serv',
                    meta: '我的应用',
                    path: '/serv',
                    component: () => import('@/views/dash/serv')
                },
                {
                    name: 'Users',
                    meta: '员工管理',
                    path: '/users',
                    component: () => import('@/views/dash/users')
                },
                {
                    name: 'deptPage',
                    meta: '企业资质',
                    path: '/dept-page',
                    component: () => import('@/views/dash/dept-page')
                },
                {
                    name: 'deptView',
                    meta: '资质框架',
                    path: '/dept-view',
                    component: () => import('@/views/dash/dept-view'),
                    children: [
                        {
                            name: 'DeptRoles',
                            meta: '企业资质列表',
                            path: '/dept-roles',
                            component: () => import('@/views/dash/dept-roles')
                        },
                        {
                            name: 'deptUreg',
                            meta: '企业资质申请记录',
                            path: '/dept-ureg',
                            component: () => import('@/views/dash/dept-ureg')
                        },
                    ]
                },
                {
                    name: 'Mine',
                    meta: '个人中心',
                    path: '/mine',
                    component: () => import('@/views/dash/mine')
                },
                {
                    name: '/uamsAdminPage',
                    meta: '资质审核列表',
                    path: '/uams-dept-roles-page',
                    component: () => import('@/views/uams/dept-roles-page'),
                },
                {
                    name: 'uamsAdminView',
                    meta: '资质审核详情',
                    path: '/uams-dept-roles-view',
                    component: () => import('@/views/uams/dept-roles-view'),
                },
                {
                    name: 'EnteInput',
                    meta: '完善信息',
                    path: '/uams/ente-input',
                    component: () => import('@/views/uams/ente-input')
                },
            ]
        },
        {
            name: 'Uams',
            meta: '后管',
            path: '/uams',
            component: () => import('@/views/uams/_index'),
            children: []
        },
        {
            name: 'AdminPage',
            meta: '资质审核列表',
            path: '/dept-roles-page',
            component: () => import('@/views/uams/dept-roles-page'),

        },
        {
            name: 'AdminView',
            meta: '资质审核详情',
            path: '/dept-roles-view',
            component: () => import('@/views/uams/dept-roles-view'),
        },
        //开发者平台
        {
            name: 'uamsMain',
            meta: '开发平台框架',
            path: '/uams_main',
            component: () => import('@/views/uams/_main'),
            children: [
                {
                    name: 'uams_index',
                    meta: '首页',
                    path: '/uams/index',
                    component: () => import('@/views/uams/_index')
                },

                /** 应用中心 **/
                {
                    name: 'AppsPage',
                    meta: '应用中心',
                    path: '/uams/apps',
                    component: () => import('@/views/uams/apps-page')
                },
                {
                    name: 'AppsPageAbiz',
                    meta: '服务目录',
                    path: '/uams/apps-abiz',
                    component: () => import('@/views/uams/apps-abiz-page')
                },
                {
                    name: 'AppsPageAcid',
                    meta: '开发单位',
                    path: '/uams/apps-acid',
                    component: () => import('@/views/uams/apps-acid-page')
                },
                {
                    name: 'AppsPageDocu',
                    meta: '开发文档',
                    path: '/uams/apps-docu',
                    component: () => import('@/views/uams/apps-docu-page')
                },
                {
                    name: 'AppsPageApis',
                    meta: '服务接口',
                    path: '/uams/apps-apis',
                    component: () => import('@/views/uams/apps-apis-page')
                },
                {
                    name: 'AppsPageApisView',
                    meta: '服务接口详情',
                    path: '/uams/apps-apis-view',
                    component: () => import('@/views/uams/apps-apis-view')
                },
                {
                    name: 'leftApp',
                    meta: '应用中心导航',
                    path: '/uams/_left-app',
                    component: () => import('@/views/uams/_left-app'),
                    children: [
                        {
                            name: 'AppsView',
                            meta: '应用详情',
                            path: '/uams/apps-view',
                            component: () => import('@/views/uams/apps-view')
                        },
                        {
                            name: 'AppsGrids',
                            meta: '视图设置',
                            path: '/uams/apps-grids',
                            component: () => import('@/views/uams/apps-grids')
                        },
                        {
                            name: 'AppsMenu',
                            meta: '应用菜单',
                            path: '/uams/apps-menu',
                            component: () => import('@/views/uams/apps-menu')
                        },
                        {
                            name: 'AppsRoles',
                            meta: '应用角色',
                            path: '/uams/apps-roles',
                            component: () => import('@/views/uams/apps-roles')
                        },
                        {
                            name: 'AppsRoots',
                            meta: '应用授权',
                            path: '/uams/apps-roots',
                            component: () => import('@/views/uams/apps-roots')
                        },
                    ]
                },
            ]
        },
        {
            path: '*',
            redirect: '/index'
        }
    ]
})

export default router